import script from "./BaseInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=570cc975&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570cc975"]])

export default __exports__